export function safeParseJSON<T>(value: string | null | undefined, fallback: T): T {
    try {
        return value ? JSON.parse(value) : fallback;
    } catch {
        return fallback;
    }
}